export const chunkArray = <T>(array: T[], arraySize: number) =>
  array.reduce(
    (acc, _item, index) =>
      index % arraySize === 0 ? [...acc, array.slice(index, index + arraySize)] : acc,
    [] as T[][]
  )
